const accessibleMenu = function (domNode) {
	this.rootNode = domNode;
	this.triggerNodes = [];
	this.controlledNodes = [];
	this.openIndex = null;
	this.useArrowKeys = true;

	this.querySelectorButtons = '.main-nav > li.menu-item-has-children > a';
	this.querySelectorSubmenu = '.sub-menu';
};

accessibleMenu.prototype.init = function () {
	const buttons = this.rootNode.querySelectorAll(this.querySelectorButtons);

	for (var i = 0; i < buttons.length; i++) {
		const button = buttons[i];
		const parent = button.parentNode;
		const menu = parent.querySelector(this.querySelectorSubmenu);

		parent.classList.add('menu-item-has-children');

		if (menu) {
			// Save ref to button and controlled menu.
			this.triggerNodes.push(button);
			this.controlledNodes.push(menu);

			// Collapse menus.
			button.setAttribute('aria-expanded', 'false');
			button.setAttribute('aria-haspopup', 'true');
			button.setAttribute('role', 'button');
			button.parentNode.classList.add('is-expanded-ff');
			this.toggleMenu(menu, false);

			// Attach event listeners.
			menu.addEventListener('keydown', this.handleMenuKeyDown.bind(this));
			button.addEventListener('click', this.handleButtonClick.bind(this));
			button.addEventListener('keydown', this.handleButtonKeyDown.bind(this));
			button.addEventListener('keyup', this.handleButtonKeyUp.bind(this));

			// append an svg to the button for the dropdown arrow
			const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			svg.setAttribute('class', 'expanded-status');
			svg.setAttribute('aria-hidden', 'true');
			svg.setAttribute('focusable', 'false');
			svg.setAttribute('width', '10');
			svg.setAttribute('height', '6');
			svg.setAttribute('viewBox', '0 0 10 6');
			svg.innerHTML =
				'<path fill-rule="evenodd" clip-rule="evenodd" d="M5 6L-5.24203e-08 1.19924L1.25099 -3.82431e-07L5 3.59962L8.749 6.03437e-06L10 1.19924L5 6Z" fill="currentColor"/>';

			button.appendChild(svg);
		}
	}

	// this.rootNode.addEventListener('focusout', this.handleBlur.bind(this));

	// focusout doesn't work in Safari, so we will use a click event anywhere except within this.rootNode
	document.addEventListener('mousedown', this.handleBlur.bind(this));
};

accessibleMenu.prototype.toggleMenu = function (domNode, show) {
	if (domNode) {
		domNode.setAttribute('aria-hidden', !show);

		if (show) {
			const focusEl = domNode.querySelector('.js-focus-on-show');
			if (focusEl) {
				setTimeout(() => focusEl.focus(), 100);
			}
		}
	}
};

function isMobileMenu() {
	// return true if $('#toggle') is visible
	return window.getComputedStyle(document.getElementById('toggle'), null).display === 'block';
}

accessibleMenu.prototype.toggleExpand = function (index, expanded) {
	// Close open menu, if applicable.
	if (this.openIndex !== index && !isMobileMenu()) {
		this.toggleExpand(this.openIndex, false);
	}

	// Handle menu at called index.
	if (this.triggerNodes[index]) {
		this.openIndex = expanded ? index : null;
		this.triggerNodes[index].setAttribute('aria-expanded', expanded);
		if (expanded) {
			this.triggerNodes[index].parentNode.classList.add('is-expanded-ff');
		} else {
			this.triggerNodes[index].parentNode.classList.remove('is-expanded-ff');
		}
		this.toggleMenu(this.controlledNodes[index], expanded);
	}
};

accessibleMenu.prototype.controlFocusByKey = function (keyboardEvent, nodeList, currentIndex) {
	switch (keyboardEvent.key) {
		case 'ArrowUp':
		case 'ArrowLeft':
			keyboardEvent.preventDefault();
			if (currentIndex > -1) {
				const prevIndex = Math.max(0, currentIndex - 1);
				nodeList[prevIndex].focus();
			}
			break;
		case 'ArrowDown':
		case 'ArrowRight':
			keyboardEvent.preventDefault();
			if (currentIndex > -1) {
				const nextIndex = Math.min(nodeList.length - 1, currentIndex + 1);
				nodeList[nextIndex].focus();
			}
			break;
		case 'Home':
			keyboardEvent.preventDefault();
			nodeList[0].focus();
			break;
		case 'End':
			keyboardEvent.preventDefault();
			nodeList[nodeList.length - 1].focus();
			break;
	}
};

/* Event Handlers */
accessibleMenu.prototype.handleBlur = function (event) {
	const menuContainsFocus = this.rootNode.contains(event.target);
	if (!menuContainsFocus && this.openIndex !== null) {
		this.toggleExpand(this.openIndex, false);
	}
};

accessibleMenu.prototype.handleButtonKeyDown = function (event) {
	const targetButtonIndex = this.triggerNodes.indexOf(document.activeElement);

	// Close the menu on the escape key.
	if (event.key === 'Escape') {
		this.toggleExpand(this.openIndex, false);
	}

	// if space bar, toggle the menu
	else if (event.key === ' ') {
		event.preventDefault();
	}

	// Move focus into the open menu if the current menu is open.
	else if (this.useArrowKeys && this.openIndex === targetButtonIndex && event.key === 'ArrowDown') {
		event.preventDefault();
		this.controlledNodes[this.openIndex].querySelector('a').focus();
	}

	// Handle arrow key navigation between top-level buttons, if set.
	else if (this.useArrowKeys) {
		this.controlFocusByKey(event, this.triggerNodes, targetButtonIndex);
	}
};

accessibleMenu.prototype.handleButtonKeyUp = function (event) {
	// space bar is handled on keyup
	// https://adrianroselli.com/2022/04/brief-note-on-buttons-enter-and-space.html
	if (event.key === ' ') {
		event.preventDefault();
		this.handleButtonClick(event);
	}
};

accessibleMenu.prototype.handleButtonClick = function (event) {
	event.preventDefault();
	const button = event.currentTarget || event.target.closest('a');
	const buttonIndex = this.triggerNodes.indexOf(button);
	const buttonExpanded = button.getAttribute('aria-expanded') === 'true';
	this.toggleExpand(buttonIndex, !buttonExpanded);
};

accessibleMenu.prototype.handleMenuKeyDown = function (event) {
	if (this.openIndex === null) {
		return;
	}

	const menuLinks = Array.prototype.slice.call(
		this.controlledNodes[this.openIndex].querySelectorAll('a'),
	);
	const currentIndex = menuLinks.indexOf(document.activeElement);

	// Close the menu on the escape key.
	if (event.key === 'Escape') {
		this.triggerNodes[this.openIndex].focus();
		this.toggleExpand(this.openIndex, false);
	}

	// Handle arrow key navigation within menu links, if set.
	else if (this.useArrowKeys) {
		this.controlFocusByKey(event, menuLinks, currentIndex);
	}
};

// Switch on/off arrow key navigation.
accessibleMenu.prototype.updateKeyControls = function (useArrowKeys) {
	this.useArrowKeys = useArrowKeys;
};

// Initialize Menus.
window.addEventListener(
	'load',
	function (event) {
		const menus = document.querySelectorAll('#header-nav');
		const accessibleMenus = [];

		for (var i = 0; i < menus.length; i++) {
			accessibleMenus[i] = new accessibleMenu(menus[i]);
			accessibleMenus[i].init();
		}
	},
	false,
);

function debounce(callback, wait = 300, immediate = false) {
	let timeout = null;

	return function () {
		const callNow = immediate && !timeout;
		const next = () => {
			callback.apply(this, arguments);
			timeout = null;
		};

		clearTimeout(timeout);
		timeout = setTimeout(next, wait);

		if (callNow) {
			next();
		}
	};
}
